export default function SVG_Links() {
  return (
    <div>
      <h1>SVG_Links Component</h1>
    </div>
  );
}
